import React from 'react';
import { Form } from 'react-bootstrap';

export const PhoneNumberInput = ({ phoneNumber, setPhoneNumber }) => {
  // Handler for phone number changes
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    // Remove non-numeric characters
    const numericValue = value.replace(/\D/g, '');

    // Format the phone number as (123) 456-7890
    let formattedNumber = '';
    if (numericValue.length <= 3) {
      formattedNumber = numericValue;
    } else if (numericValue.length <= 6) {
      formattedNumber = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
    } else if (numericValue.length <= 10) {
      formattedNumber = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
    }

    setPhoneNumber(formattedNumber);
  };

  return (
    <Form.Group>
      <Form.Control
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneNumberChange}
        placeholder="(xxx)xxx-xxxx"
        maxLength="14" // Maximum length, considering formatting characters
      />
    </Form.Group>
  );
};

export const formatPhoneNumberForSubmission = (displayedNumber) => {
  const numericValue = displayedNumber.replace(/\D/g, ''); 
  if (numericValue.startsWith('1') && numericValue.length === 11) {
    return `+${numericValue}`;
  }
  return `+1${numericValue}`;
};
